
    /* ==========================================================
       NAGOMI · Interactive layer
       ========================================================== */
    (() => {
      'use strict';

      // ---------- Nav: scroll-condensed state ----------
      const nav = document.getElementById('nav');
      const onScroll = () => {
        if (nav) nav.classList.toggle('scrolled', window.scrollY > 20);
        // Sticky mobile CTA shows after scrolling past hero
        const stickyCta = document.getElementById('sticky-cta');
        const buy = document.getElementById('buy');
        if (stickyCta && buy) {
          const buyTop = buy.getBoundingClientRect().top;
          const buyBottom = buy.getBoundingClientRect().bottom;
          const past600 = window.scrollY > 600;
          const buyInView = buyTop < window.innerHeight && buyBottom > 0;
          stickyCta.classList.toggle('show', past600 && !buyInView);
        }
      };
      window.addEventListener('scroll', onScroll, { passive: true });
      onScroll();

      // ---------- Mobile menu ----------
      const burger = document.getElementById('burger');
      const mobileMenu = document.getElementById('mobile-menu');
      if (burger && mobileMenu) {
        burger.addEventListener('click', () => {
          const open = burger.classList.toggle('open');
          mobileMenu.classList.toggle('open', open);
          mobileMenu.setAttribute('aria-hidden', String(!open));
          burger.setAttribute('aria-expanded', String(open));
          document.body.style.overflow = open ? 'hidden' : '';
        });
        mobileMenu.querySelectorAll('a').forEach(a => a.addEventListener('click', () => {
          burger.classList.remove('open');
          mobileMenu.classList.remove('open');
          document.body.style.overflow = '';
        }));
      }


      // ---------- Quantity stepper ----------
      const qtyInput = document.getElementById('qty-input');
      const qtyMinusBtn = document.getElementById('qty-minus');
      const qtyPlusBtn = document.getElementById('qty-plus');
      if (qtyInput && qtyMinusBtn && qtyPlusBtn) {
        qtyMinusBtn.addEventListener('click', () => {
          const v = Math.max(1, parseInt(qtyInput.value || '1', 10) - 1);
          qtyInput.value = v;
        });
        qtyPlusBtn.addEventListener('click', () => {
          const v = Math.min(10, parseInt(qtyInput.value || '1', 10) + 1);
          qtyInput.value = v;
        });
        qtyInput.addEventListener('input', () => {
          let v = parseInt(qtyInput.value, 10);
          if (isNaN(v) || v < 1) v = 1;
          if (v > 10) v = 10;
          qtyInput.value = v;
        });
      }

      // ---------- Accordion (buy box & FAQ) ----------
      const setupAccordion = (triggerSel, itemSel, bodySel) => {
        document.querySelectorAll(triggerSel).forEach(trigger => {
          trigger.addEventListener('click', () => {
            const item = trigger.closest(itemSel);
            const body = item.querySelector(bodySel);
            const isOpen = item.classList.contains('open');
            item.classList.toggle('open');
            trigger.setAttribute('aria-expanded', String(!isOpen));
            if (!isOpen) {
              body.style.maxHeight = body.scrollHeight + 'px';
            } else {
              body.style.maxHeight = '0';
            }
          });
        });
      };
      setupAccordion('.acc-trigger', '.acc-item', '.acc-body');
      setupAccordion('.faq-trigger', '.faq-item', '.faq-body');

      // ---------- Thumbnail gallery ----------
      const buyMainImg = document.getElementById('buy-main-current');
      document.querySelectorAll('.buy-thumb').forEach(thumb => {
        thumb.addEventListener('click', () => {
          document.querySelectorAll('.buy-thumb').forEach(t => t.classList.remove('active'));
          thumb.classList.add('active');
          // Swap main image to the high-res source from the thumbnail's data-src
          const newSrc = thumb.dataset.src;
          if (buyMainImg && newSrc) {
            buyMainImg.style.opacity = '0';
            setTimeout(() => {
              buyMainImg.src = newSrc;
              buyMainImg.style.opacity = '1';
            }, 200);
          }
        });
      });

      // ---------- Countdown (resets daily, creates honest urgency) ----------
      const countdownEl = document.getElementById('countdown');
      if (countdownEl) {
        const updateCountdown = () => {
          const now = new Date();
          const end = new Date();
          end.setHours(23, 59, 59, 999);
          let diff = Math.max(0, Math.floor((end - now) / 1000));
          const h = String(Math.floor(diff / 3600)).padStart(2, '0');
          const m = String(Math.floor((diff % 3600) / 60)).padStart(2, '0');
          const s = String(diff % 60).padStart(2, '0');
          countdownEl.textContent = `${h}:${m}:${s}`;
        };
        updateCountdown();
        setInterval(updateCountdown, 1000);
      }

      // ---------- Toast ----------
      const toast = document.getElementById('toast');
      const toastMsg = document.getElementById('toast-msg');
      let toastTimer;
      const showToast = (msg) => {
        if (!toast || !toastMsg) return;
        toastMsg.textContent = msg;
        toast.classList.add('show');
        clearTimeout(toastTimer);
        toastTimer = setTimeout(() => toast.classList.remove('show'), 3200);
      };

      // ---------- Add to cart ----------
      let cartCount = 0;
      const cartCountEl = document.getElementById('cart-count');
      const addForm = document.getElementById('nagomi-add-form');
      const addBtn = document.getElementById('add-to-cart');
      if (addForm) {
        addForm.addEventListener('submit', async (e) => {
          e.preventDefault();
          const qty = qtyInput ? (parseInt(qtyInput.value, 10) || 1) : 1;
          const addQtyHidden = document.getElementById('add-qty-hidden');
          if (addQtyHidden) addQtyHidden.value = qty;
          if (addBtn) {
            addBtn.disabled = true;
            addBtn.dataset.label = addBtn.innerHTML;
            addBtn.innerHTML = 'Adding…';
          }
          try {
            const fd = new FormData(addForm);
            const res = await fetch('/cart/add.js', {
              method: 'POST',
              body: fd,
              headers: { Accept: 'application/json' }
            });
            if (res.ok) {
              showToast('Added to your ritual. Taking you to your cart…');
              setTimeout(() => { window.location.href = '/cart'; }, 700);
            } else {
              let msg = 'Could not add — please try again.';
              try {
                const err = await res.json();
                if (err && err.description) msg = err.description;
                else if (err && err.message) msg = err.message;
              } catch (_) {}
              showToast(msg);
              if (addBtn) {
                addBtn.disabled = false;
                if (addBtn.dataset.label) addBtn.innerHTML = addBtn.dataset.label;
              }
            }
          } catch (err) {
            // Network failure: fall back to native form submit (full page POST)
            addForm.submit();
          }
        });
      }
      const cartBtnEl = document.getElementById('cart-btn');
      if (cartBtnEl) cartBtnEl.addEventListener('click', () => { window.location.href = '/cart'; });
      fetch('/cart.js').then(r => r.json()).then(cart => { cartCount = cart.item_count || 0; if (cartCountEl) cartCountEl.textContent = cartCount; }).catch(() => {});

      // ---------- Newsletter forms ----------
      const handleNewsletter = (formId, msg) => {
        const form = document.getElementById(formId);
        if (!form) return;
        form.addEventListener('submit', e => {
          e.preventDefault();
          const email = form.querySelector('input[type="email"]').value.trim();
          if (!email || !email.includes('@')) {
            showToast('Please use a valid email.');
            return;
          }
          form.reset();
          showToast(msg);
        });
      };
      handleNewsletter('newsletter-form', 'Welcome to the letter.');
      // ---------- Reveal on scroll ----------
      const io = new IntersectionObserver((entries) => {
        entries.forEach(e => {
          if (e.isIntersecting) {
            e.target.classList.add('in');
            io.unobserve(e.target);
          }
        });
      }, { threshold: 0.15, rootMargin: '0px 0px -60px 0px' });
      document.querySelectorAll('.reveal, .reveal-stagger').forEach(el => io.observe(el));

      // ==========================================================
      // QUIZ
      // 5 questions → mapped to 3 result archetypes
      // (all recommend the same hero device, with different framing copy)
      // ==========================================================
      const quizQuestions = [
        {
          q: "How does your scalp feel by <em>evening</em>?",
          options: [
            { label: "Tight and tender to the touch", type: "quiet" },
            { label: "Oily, like it needs another wash", type: "reset" },
            { label: "Itchy, flaky, restless", type: "reset" },
            { label: "Fine — just tired with the rest of me", type: "quiet" }
          ]
        },
        {
          q: "What is your hair quietly <em>telling</em> you?",
          options: [
            { label: "The part-line is widening", type: "restorative" },
            { label: "I'm shedding more in the shower", type: "restorative" },
            { label: "It's flatter than it used to be", type: "restorative" },
            { label: "No concerns — I'm here for the ritual", type: "quiet" }
          ]
        },
        {
          q: "How do you <em>wind down</em> at night?",
          options: [
            { label: "Screens, until I fall asleep on them", type: "quiet" },
            { label: "I read or journal", type: "quiet" },
            { label: "Honestly, I don't — I crash", type: "quiet" },
            { label: "Yoga, breath, or a long shower", type: "reset" }
          ]
        },
        {
          q: "Your hair routine, as it stands?",
          options: [
            { label: "Just shampoo and conditioner", type: "reset" },
            { label: "Serums, masks, the whole shelf", type: "restorative" },
            { label: "I'm minimalist — and proud of it", type: "quiet" },
            { label: "Kitchen-sink — name it, I've tried it", type: "restorative" }
          ]
        },
        {
          q: "What would <em>better</em> look like, in 84 nights?",
          options: [
            { label: "Less stress, the rest sorts itself out", type: "quiet" },
            { label: "Visibly more density at the part", type: "restorative" },
            { label: "A scalp that feels alive again", type: "reset" },
            { label: "A practice I'd actually keep", type: "quiet" }
          ]
        }
      ];

      const quizResults = {
        quiet: {
          name: "The Quiet",
          tagline: "— for the over-tired",
          desc: "Your scalp is holding the weight your shoulders won't admit. The Ritual leads with sonic — three minutes of vibration that softens the jaw before it touches the follicle. Light therapy and the Drops follow.",
          mode: "Sonic-led · 7 min nightly"
        },
        restorative: {
          name: "The Restorative",
          tagline: "— for the density-curious",
          desc: "You're working on the long game, and so is the Ritual. Clinical red light at 630 nm anchors the routine — five minutes of capillary work, with sonic and Drops keying the rest. Most see visible density gains by night 84.",
          mode: "Light-led · 7 min nightly"
        },
        reset: {
          name: "The Reset",
          tagline: "— for the rebuilders",
          desc: "Your scalp wants its bed reset. The Ritual opens with deep-cleansing sonic, lifts the buildup, then layers in the Botanical Drops — niacinamide-led to restore the barrier. Itch and oiliness usually settle by week three.",
          mode: "Drops-led · 7 min nightly"
        }
      };

      const quizState = { step: 0, answers: [] };
      const stage = document.getElementById('quiz-stage');
      const stepLabel = document.getElementById('quiz-step-label');
      const progressBar = document.getElementById('quiz-progress');
      const backBtn = document.getElementById('quiz-back');
      const helpText = document.getElementById('quiz-help');

      if (stage && stepLabel && progressBar && backBtn && helpText) {
      const renderQuestion = () => {
        const q = quizQuestions[quizState.step];
        const total = quizQuestions.length;
        stepLabel.textContent = `Question ${String(quizState.step + 1).padStart(2, '0')} of ${String(total).padStart(2, '0')}`;
        progressBar.style.width = `${((quizState.step) / total) * 100}%`;
        backBtn.disabled = quizState.step === 0;
        helpText.style.display = '';

        const letters = ['a', 'b', 'c', 'd'];
        stage.innerHTML = `
          <div class="quiz-step active">
            <h3 class="quiz-q">${q.q}</h3>
            <div class="quiz-options">
              ${q.options.map((o, i) => `
                <button class="quiz-opt" data-type="${o.type}" data-idx="${i}">
                  <span class="quiz-opt-letter">${letters[i]}</span>
                  <span>${o.label}</span>
                </button>
              `).join('')}
            </div>
          </div>
        `;

        stage.querySelectorAll('.quiz-opt').forEach(btn => {
          btn.addEventListener('click', () => {
            quizState.answers[quizState.step] = btn.dataset.type;
            if (quizState.step < quizQuestions.length - 1) {
              quizState.step++;
              renderQuestion();
            } else {
              renderResult();
            }
          });
        });
      };

      const renderResult = () => {
        const counts = { quiet: 0, restorative: 0, reset: 0 };
        quizState.answers.forEach(a => { if (counts[a] !== undefined) counts[a]++; });
        const winner = Object.entries(counts).sort((a, b) => b[1] - a[1])[0][0];
        const r = quizResults[winner];

        stepLabel.textContent = 'Your ritual';
        progressBar.style.width = '100%';
        backBtn.disabled = false;
        helpText.style.display = 'none';

        stage.innerHTML = `
          <div class="quiz-step active">
            <div class="quiz-result">
              <div class="quiz-result-eyebrow">${r.tagline}</div>
              <h3>You're <em>${r.name}</em>.</h3>
              <p>${r.desc}</p>

              <div class="quiz-result-rec">
                <div class="quiz-result-img">
                  <svg viewBox="0 0 90 90" style="width:100%;height:100%">
                    <ellipse cx="45" cy="45" rx="22" ry="18" fill="#0F1722"/>
                    <ellipse cx="45" cy="51" rx="22" ry="4" fill="#7B5BA6"/>
                    <rect x="41" y="58" width="8" height="20" rx="3" fill="#0F1722"/>
                  </svg>
                </div>
                <div class="quiz-result-info">
                  <div class="quiz-result-info-title">The <em>Ritual</em>™ Device</div>
                  <div class="quiz-result-info-meta">${r.mode} · $79 (was $129)</div>
                </div>
              </div>

              <div class="quiz-result-cta">
                <a href="#buy" class="btn btn-brass" data-quiz-cta>Start my ${r.name} ritual <span class="arr">→</span></a>
                <button class="btn btn-ghost" id="quiz-restart">Take it again</button>
              </div>
            </div>
          </div>
        `;

        document.getElementById('quiz-restart').addEventListener('click', () => {
          quizState.step = 0;
          quizState.answers = [];
          renderQuestion();
        });
      };

      backBtn.addEventListener('click', () => {
        if (quizState.step > 0) {
          quizState.step--;
          quizState.answers.pop();
          renderQuestion();
        }
      });

      renderQuestion();
      } // end quiz guard

      // ---------- Smooth scroll for anchor links ----------
      document.querySelectorAll('a[href^="#"]').forEach(a => {
        a.addEventListener('click', e => {
          const id = a.getAttribute('href');
          if (id === '#' || id.length < 2) return;
          const target = document.querySelector(id);
          if (!target) return;
          e.preventDefault();
          const top = target.getBoundingClientRect().top + window.scrollY - 70;
          window.scrollTo({ top, behavior: 'smooth' });
        });
      });

      // ---------- Scroll progress indicator ----------
      const scrollProgress = document.getElementById('scroll-progress');
      if (scrollProgress) {
        const updateScrollProgress = () => {
          const docH = document.documentElement.scrollHeight - window.innerHeight;
          const pct = docH > 0 ? (window.scrollY / docH) * 100 : 0;
          scrollProgress.style.width = pct + '%';
        };
        window.addEventListener('scroll', updateScrollProgress, { passive: true });
        updateScrollProgress();
      }

      // ---------- Rotating featured testimonial ----------
      const fqItems = document.querySelectorAll('.feature-quote-item');
      const fqDots = document.querySelectorAll('.fq-dot');
      let fqIdx = 0;
      let fqTimer;
      const fqGoTo = (i) => {
        fqIdx = (i + fqItems.length) % fqItems.length;
        fqItems.forEach(el => el.classList.toggle('active', parseInt(el.dataset.i, 10) === fqIdx));
        fqDots.forEach(d => d.classList.toggle('active', parseInt(d.dataset.i, 10) === fqIdx));
      };
      const fqAuto = () => {
        clearInterval(fqTimer);
        fqTimer = setInterval(() => fqGoTo(fqIdx + 1), 6000);
      };
      fqDots.forEach(d => d.addEventListener('click', () => {
        fqGoTo(parseInt(d.dataset.i, 10));
        fqAuto();
      }));
      // Pause rotation on hover (respects user attention)
      const fqContainer = document.getElementById('feature-quote');
      if (fqContainer) {
        fqContainer.addEventListener('mouseenter', () => clearInterval(fqTimer));
        fqContainer.addEventListener('mouseleave', fqAuto);
        fqAuto();
      }

    })();
